import { Component } from '@angular/core';
import { Location } from '@angular/common';
import { TraceableComponent } from 'src/app/api/traceable-components/traceableComponent';
import { TraceableComponentsApiService } from 'src/app/api/traceable-components/traceableComponentsApiService';
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'traceable-component-details',
    templateUrl: './traceable-component-details.component.html',
    styleUrls: ['./traceable-component-details.component.css'],
    standalone: false
})
export class TraceableComponentDetailsComponent {
  loading: boolean = false;
  traceableComponent: TraceableComponent | null = null;
  source: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private location: Location,
    private traceableComponentApiService: TraceableComponentsApiService
  ) {
    this.route.params.subscribe(() => {
      this.source = this.route.snapshot.paramMap.get('source') as string;
      if (this.source == null)
        return;

      const idParam = this.route.snapshot.paramMap.get('id') as unknown;
      const id = idParam as number;
      if (id == null)
        return;

      this.loadComponent(this.source!, id);
    });
  }

  loadComponent(source: string, id: number): void {
    this.loading = true;
    this.traceableComponentApiService.getTraceableComponent(id, source)
      .subscribe(x => {
        this.traceableComponent = x;
        this.loading = false;
      });
  }

  back(): void {
    this.location.back()
  }
}
